import { useEffect } from "react";

/**
 * Injects JSON-LD structured data into the document head.
 * Cleans up on unmount to prevent duplicate schemas.
 */
const StructuredData = ({ data }) => {
  useEffect(() => {
    if (!data) return;

    const schemas = Array.isArray(data) ? data : [data];
    const scripts = schemas.map((schema) => {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.text = JSON.stringify(schema);
      document.head.appendChild(script);
      return script;
    });

    return () => {
      scripts.forEach((script) => {
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
      });
    };
  }, [data]);

  return null;
};

export default StructuredData;
